/** ContentSquare / session-replay masking class for PII summary lines. */
export const SESSION_REPLAY_MASK_CLASS = 'pii';
